<template>
    <div class="kidjo-header">
      
      <div class="content-overlay">
        
        <!-- Main Title -->
        <h1 class="main-title-LP" :class="$i18n.locale === 'ar' ? 'arabic-text' : ''">
          {{ $t('landing_page_title') }}
        </h1>
        
        <!-- Price Display -->
        <div class="price-container">
          <div class="period">{{$t('landing_page_subtitle')}}</div>
          <div class="price">
            <span class="amount">{{getPriceToDispaly()}}</span>
          </div>
          <div class="period">{{ $t('landing_page_subtitle_header_month') }}</div>
        </div>
        <form @submit.prevent="handleSubmit" class="signup-form">
          <TextInputField 
						:modelValue="email"
						@update:modelValue="email = $event"
						:field-type="'text'"
						name="email"
						:placeholder="$t('login_page_box_form_email')" 
						:has-error="email_error"
						:is-required-value="true"
					/>
          <SubmitButton :label="$t('landing_page_subtitle_free_trial')" :isLoading="false" type="submit" />
          <p class="trial-text" :class="$i18n.locale === 'ar' ? 'arabic-text' : ''">{{ dispalyYearlyPriceInLabel('landing_page_button_subtitle') }}</p>

        </form>      
          <div class="rating-container grid-container">
            <img src="../assets/images/left-border.svg" alt="Apple" class="left-border">
            <span class="downloads">{{ $t('landing_page_header_ratings') }}</span>
            <div class="stars">
              <img src="../assets/images/stars-rating.svg" alt="Apple">
            </div>
            <div class="ratings">
              <div class="rating">
                <img src="../assets/images/white-apple.svg" alt="Apple">
                <span>4.7</span>
              </div>
              <div class="rating">
                <img src="../assets/images/white-google-play.svg" alt="Google Play">
                <span>4.3</span>
              </div>
            </div>
            <img src="../assets/images/right-border.svg" alt="Apple" class="right-border">
          </div>
      </div>
    </div>
  </template>
  <script>
  
	import TextInputField from '../components/TextInputField.vue';
	import SubmitButton from '../components/SubmitButton.vue';
  import PriceMixin from '../mixins/price';
  export default {
    name: 'KidjoHeader',
		mixins: [PriceMixin],
		components: {
			"TextInputField": TextInputField,
			"SubmitButton": SubmitButton
		},
    data() {
      return {
        email: '',
				email_error: false,
      }
    },
    props: {
      price: {
        type: String,
        default: '0,99€'
      },
      trialDays: {
        type: Number,
        default: 7
      }
    },
    methods: {
      handleSubmit: function() {
        if (this.email === '' || this.email === null) {
					this.email_error = true;
          return
				}
        this.$store.commit('setAccountEmail', this.email);
        this.$router.replace({name: 'register'});
      }
    }
  }
  </script>
  
  <style scoped>
  .kidjo-header {
    width: 100%;
    background-color: #020076;
    overflow: hidden;
    background-image: url('../assets/backgrounds/mobileHeaderBackground.svg');
    background-size:cover;
    background-position: center;
    background-repeat: no-repeat;

    @media (min-width: 1024px) {
      background-image: url('../assets/backgrounds/background-header.svg');
      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;
    }
  }
  .logo-container {
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 3; /* Higher than other elements to ensure visibility */
  }

  .kidjo-logo {
    width: 80px;
    height: auto;
    transition: transform 0.3s ease;
  }

  .kidjo-logo:hover {
    transform: scale(1.05);
  }
  .character-grid {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: grid;
    /* grid-template-columns: repeat(auto-fill, minmax(100px, 1fr)); */
    gap: 10px;
    padding: 20px;
    opacity: 0.3;
  }
  
  .character-box {
    aspect-ratio: 1;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 15px;
    transition: all 0.3s ease;
  }
  
  .character-box:hover {
    transform: scale(1.05);
    background-color: rgba(255, 255, 255, 0.2);
  }
  
  .content-overlay {
    position: relative;
    z-index: 2;
    max-width: 800px;
    margin: 0 auto;
    padding: 0px 20px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 600px;
    width: 100%;

    @media (orientation: portrait) {
      min-height: 50dvh;
      margin-top: 15%;
      padding-bottom: 10px;
    }
  }
  .main-title-LP {
    color: white;
    font-size: 1.8rem;
    font-weight: bold;
    line-height: 1.2;
    text-align: center;
    font-family: "Nunito-ExtraBold";
    text-transform: uppercase;
  }
  
  .price {
    display: inline-flex;
  }
  
  .amount {
    font-size: 4rem;
    font-weight: bold;
    color: white;
    line-height: 1.2;
    font-family: "Nunito-ExtraBold";
  }
  
  .period {
    font-size: 1.2rem;
    color: white;
    margin-block: 8px;
    font-family: "Nunito-Regular";
    margin-bottom: 15px;
  }
  .signup-form {
    display: grid;
    row-gap: 10px;
    width: 45%;
    margin: 0 auto;
    font-family: "Nunito-Regular";
    
    @media (min-width: 1024px) {
      width: 45%;
    }
    @media (orientation: portrait) {
      width: 75%;
    }
    @media (orientation: landscape) and (max-height: 480px) {
      max-width: 50%;
    }
    @media (orientation: portrait) and (min-width: 1000px) {
      width: 55%;
    }
    @media screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
      width: 53%;
    }
  }
  .payment-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
  
  
  .trial-text {
    color: white;
    font-size: 0.9rem;
    font-family: "Nunito-Regular";
    margin-block: 10px;
  }
  
  /* Responsive Design */
  @media (max-width: 1024px) {
    .character-grid {
      /* grid-template-columns: repeat(auto-fill, minmax(80px, 1fr)); */
    }
  }
  
  @media (max-width: 768px) {
    .kidjo-header {
    }
    
    .content-overlay {
      padding: 0px 15px;
    }
    
    .main-title-LP {
      font-size: 1.5rem;
    }
    
    .amount {
      font-size: 3rem;
    }
    
    .character-grid {
      /* grid-template-columns: repeat(auto-fill, minmax(60px, 1fr)); */
    }
  }
  
  @media (max-width: 480px) {
    .kidjo-header {
    }
    
    .content-overlay {
      padding: 0px 10px;
    }
    
    .main-title-LP {
      font-size: 1.5rem;
      margin-top: 15px;
    }
    
    .amount {
      font-size: 2.5rem;
    }
    
    .character-grid {
      /* grid-template-columns: repeat(auto-fill, minmax(50px, 1fr)); */
      gap: 5px;
    }
    
    .kidjo-logo {
      width: 90px;
      margin-bottom: 20px;
    }
  }
  
  /* Animation for character boxes */
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 0.3;
      transform: translateY(0);
    }
  }
  
  .character-box {
    animation: fadeIn 0.5s ease forwards;
    animation-delay: calc(var(--index) * 0.1s);
  }
  
  /* High contrast mode and accessibility */
  @media (prefers-contrast: high) {
    .trial-text {
      opacity: 1;
    }
  }
  
  /* Reduced motion preferences */
  @media (prefers-reduced-motion: reduce) {
    .character-box {
      animation: none;
    }
  }
  
.rating-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
  position: relative;
  z-index: 9999;
  max-width: 250px; /* Adjust width as needed */

  /* Left & Right Decorative Borders */
  &::before,
  &::after {
    content: "";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 20px;
    height: 40px;
  }

  &::before {
    left: -25px;
  }

  &::after {
    right: -25px;
  }

  .downloads {
    font-weight: bold;
    font-size: 14px;
    font-family: "Nunito-Regular";
  }

  .stars {
    margin-block: 10px;
  }

  .ratings {
    display: flex;
    justify-content: center;
    gap: 15px;

    .rating {
      display: flex;
      align-items: center;
      gap: 5px;

      img {
        width: 20px;
        height: 20px;
      }

      span {
        font-size: 14px;
        font-family: "Nunito-ExtraBold";
      }
    }
  }
  @media (orientation: portrait) {
    padding-bottom: 10px;
  }
}
.grid-container {
  display: grid;
  margin-top: 10px;
  gap: 2px 15px;
  grid-template-columns: auto auto auto;
  margin-bottom: 1%;
  @media (orientation: portrait) {
    margin-bottom: 5%;
  }
}

.grid-container > div {
  text-align: center;
  font-size: 30px;
}
.left-border {
  grid-row-start: 1;
  grid-row-end: 4;
}
.right-border {
  grid-column: 3;
  grid-row-start: 1;
  grid-row-end: 4;
}
  </style>